import React, { forwardRef } from 'react';
import { View, Text, Image, StyleSheet } from 'react-native';

const W = 1200;
const H = 675;

function HalfPanel({ members = [], date = '', time = '', head_1 = '', head_2 = '', code = '', logoUri = null }) {
  return (
    <View style={panelStyles.root}>
      {/* Member list */}
      <View style={panelStyles.memberList}>
        {members.slice(0, 8).map((m, i) => m ? (
          <Text key={i} style={panelStyles.memberText}>
            {m.name}{m.age ? ` - ${m.age}` : ''}
          </Text>
        ) : null)}
      </View>

      {/* Heads */}
      <View style={panelStyles.headsBlock}>
        <Text style={panelStyles.headText}>{head_1}</Text>
        <Text style={panelStyles.headText}>{head_2}</Text>
      </View>

      {/* Date/time */}
      <Text style={panelStyles.dateText}>{date}</Text>
      <Text style={panelStyles.dateText}>{time}</Text>

      {/* Code badge */}
      <View style={panelStyles.codeBlock}>
        <Text style={panelStyles.codeText}>{code}</Text>
      </View>

      {/* Logo */}
      {logoUri && (
        <Image source={{ uri: logoUri }} style={panelStyles.logo} resizeMode="contain" />
      )}
    </View>
  );
}

const FamilyLabelView = forwardRef(function FamilyLabelView({ data }, ref) {
  const { members = [], date = '', time = '', head_1 = '', head_2 = '', code = '', logoUri = null } = data || {};

  const halfProps = { members, date, time, head_1, head_2, code, logoUri };

  return (
    <View ref={ref} style={styles.root}>
      <HalfPanel {...halfProps} />
      <View style={styles.verticalDivider} />
      <HalfPanel {...halfProps} />
    </View>
  );
});

const styles = StyleSheet.create({
  root: {
    width: W,
    height: H,
    backgroundColor: '#fff',
    flexDirection: 'row',
  },
  verticalDivider: {
    width: 2,
    backgroundColor: '#000',
  },
});

const panelStyles = StyleSheet.create({
  root: {
    flex: 1,
    paddingHorizontal: 18,
    paddingVertical: 14,
  },
  memberList: {
    flex: 1,
  },
  memberText: {
    fontSize: 30,
    color: '#000',
    fontFamily: 'System',
    lineHeight: 36,
    textAlign: 'center',
  },
  headsBlock: {
    marginVertical: 6,
    alignItems: 'center',
  },
  headText: {
    fontSize: 24,
    fontWeight: '700',
    fontStyle: 'italic',
    color: '#000',
    fontFamily: 'System',
    textAlign: 'center',
  },
  dateText: {
    fontSize: 24,
    color: '#000',
    fontFamily: 'System',
    textAlign: 'center',
  },
  codeBlock: {
    backgroundColor: '#000',
    borderRadius: 10,
    paddingHorizontal: 16,
    paddingVertical: 8,
    alignSelf: 'center',
    marginTop: 8,
    minWidth:200
  },
  codeText: {
    fontSize: 32,
    fontWeight: '700',
    color: '#fff',
    fontFamily: 'System',
    textAlign: 'center',
  },
  logo: {
    width: 200,
    height: 64,
    marginTop: 8,
    alignSelf: 'center',
  },
});

export default FamilyLabelView;
